// Navigate from outside a component (after a dialog saves, say). The shell registers the router's navigate.
import type { NavigateFunction } from "react-router";

let navigate: NavigateFunction | null = null;
export const setNavigate = (n: NavigateFunction) => { navigate = n; };
/** go("/lead/12"): the app route, without the "#". */
export const go = (to: string) => { if (navigate) void navigate(to); else location.hash = "#" + to; };
